import { observable, action, decorate } from 'mobx';
import { GET_DATA_CHARTS } from 'api';

class InvestmentIncomeModule {
    graphicsData = [];

    initialization = false;

    loading = true;

    getGraphicsData(index, policyId) {
        return GET_DATA_CHARTS(index, policyId).then((data) => {
            this.graphicsData = data;
        });
    }

    setInitialization(value) {
        this.initialization = value;
    }

    setLoading(value) {
        this.loading = value;
    }
}

decorate(InvestmentIncomeModule, {
    graphicsData: observable,
    initialization: observable,
    loading: observable,
    getGraphicsData: action.bound,
    setInitialization: action.bound,
    setLoading: action.bound,
});

export default InvestmentIncomeModule;
